import { categories } from "@/mocks/categories";

export default function FeatureGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      {/* Top Text */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12">
        <div className="lg:w-1/2">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Shop by
            <br />
            Category
          </h2>
        </div>
        <div className="lg:w-1/2 lg:pt-2">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md lg:ml-auto">
            Browse our curated mulebuy spreadsheet categories to discover trending
            products across fashion, accessories, and lifestyle — all organized for
            fast, intuitive browsing.
          </p>
        </div>
      </div>

      {/* Feature Cards - Asymmetric Layout */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-5">
        {/* Left - Large Card (Shoes) */}
        <a
          href={categories[0].url}
          target="_blank"
          rel="noopener nofollow"
          className="md:col-span-2 group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden h-full flex flex-col border border-background-200/70 hover:border-background-300/60 transition-all">
            <div className="relative w-full h-56 md:h-72 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20pair%20of%20cream%20beige%20minimal%20leather%20sneakers%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20elegant%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20isolated%20product%20shot%20with%20delicate%20shadows&width=600&height=500&seq=mulebuy-feat-shoes-x2&orientation=portrait"
                alt="Shoes category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Shoes
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col gap-2">
              <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
                Trending Sneakers &amp; Footwear
              </h3>
              <p className="text-sm text-foreground-600">
                Curated sneakers, casual footwear, and athletic shoes updated daily with the latest releases
              </p>
            </div>
          </div>
        </a>

        {/* Middle - Hoodies/Sweaters */}
        <a
          href={categories[1].url}
          target="_blank"
          rel="noopener nofollow"
          className="md:col-span-1.5 group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden h-full flex flex-col border border-background-200/70 hover:border-background-300/60 transition-all">
            <div className="p-5 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950">
                Hoodies &amp; Sweaters
              </h3>
              <p className="text-sm text-foreground-600 mt-2">
                Seasonal hoodies, crewnecks, and knitwear for every style
              </p>
            </div>
            <div className="relative w-full h-48 md:h-56 overflow-hidden mt-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20an%20oversized%20oatmeal%20beige%20chunky%20knit%20sweater%20draped%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20cozy%20texture%20with%20delicate%20shadows&width=600&height=500&seq=mulebuy-feat-hoodies-x2&orientation=portrait"
                alt="Hoodies category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  Hoodies
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* Right - T-Shirts */}
        <a
          href={categories[2].url}
          target="_blank"
          rel="noopener nofollow"
          className="md:col-span-1.5 group cursor-pointer"
        >
          <div className="bg-white rounded-2xl overflow-hidden h-full flex flex-col border border-background-200/70 hover:border-background-300/60 transition-all">
            <div className="p-5 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950">
                T-Shirts
              </h3>
              <p className="text-sm text-foreground-600 mt-2">
                Graphic tees, basics, and statement pieces curated weekly
              </p>
            </div>
            <div className="relative w-full h-48 md:h-56 overflow-hidden mt-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20terracotta%20warm%20orange%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20simple%20editorial%20style%20high%20quality%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20clean%20isolated%20product%20shot&width=600&height=500&seq=mulebuy-feat-tshirts-x2&orientation=portrait"
                alt="T-Shirts category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 left-3">
                <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-foreground-900">
                  T-Shirts
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}